export default __webpack_public_path__ + "static/media/AR.56a03bf2.ico";